<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Your Lead Preferences
      </content-page-title>
    </template>

    <PropertyTypes :pro="me" />
    <Services :pro="me" />
  </ContentPage>
</template>

<script>

import { ContentPage, ContentPageTitle } from '@/components/pages'
import PropertyTypes from './PropertyTypes'
import Services from './Services'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ContentPage,
    ContentPageTitle,
    PropertyTypes,
    Services,
  },
  
  computed: {
    ...mapGetters('auth', { me: 'me' })
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  },
}
</script>